import { JSX } from 'react';
import { HeadlineWithOptionalCta } from '@ahc-digital/component-library';
import { C03HeadlineWithOptionalCTAProps } from './C03HeadlineWithOptionalCTA.types';
import { GetHeadlineWIthOptionalCTAModel } from './C03HeadlineWithOptionalCTA.service';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C03HeadlineWithOptionalCTAProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <HeadlineWithOptionalCta
      data-component={marketingRenderingName}
      {...GetHeadlineWIthOptionalCTAModel(props)}
    />
  );
};

export default checkDatasourceForRendering<C03HeadlineWithOptionalCTAProps>(Default);
